module.exports = __webpack_public_path__ + "img/groups-icon.690d341a.svg";